import { render, staticRenderFns } from "./AssembleList.vue?vue&type=template&id=5498fd7a&scoped=true"
import script from "./AssembleList.vue?vue&type=script&lang=js"
export * from "./AssembleList.vue?vue&type=script&lang=js"
import style0 from "./AssembleList.vue?vue&type=style&index=0&id=5498fd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@7.1.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5498fd7a",
  null
  
)

export default component.exports